import styled from "styled-components";

export const Wrapper = styled.div`
   
    height: 100%;
    padding: 20px 10px;
   

    &:before {
        background: #131f28;
        opacity: 0.9;
    }
    .logo {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;

        img {
            height: 40px;
        }
    }

    .button-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin: 20px 0;

        button {
            background: #000000;
            border: none;
            font-size: 18px;
            font-weight: 600;
            padding: 5px;
            width: 150px;
            border-radius: 5px;
            color: white;
        }
    }

`;